import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from './redux/store';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';

const App = React.lazy(() => import(/* webpackChunkName: "App" */'./App'));

ReactDOM.render(
  <Provider store={configureStore()}>
    <Suspense fallback={<div className="loading" />}>
      <App />
    </Suspense>

  </Provider>,
  document.getElementById('root')
);
serviceWorker.unregister();
